import React, { useState, useEffect } from 'react';
import { Justify, Row, Col, Card } from 'tea-component';
import { useIntl, useSelector } from 'umi';
import SvgIcon from '../../SvgIcon';
import NoData from './components/NoData';
import LodingData from './components/LodingData';
import {
  fetchSearchHistories,
  deleteHistory,
} from '@/pages/home/services/search';
import {
  updateSearchPageUrl,
  getSearchRelease,
  getSearchPageParams,
} from '@/pages/home/utils/search';
import CardHomeItem from './components/CardHomeItem';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
import { PageLogMes } from '@/pages/home/utils/buriedPointCfg';

export default function SearchHome(props: any) {
  const {
    trendingList,
    searchTrendingsLoading,
    addSearchHistory,
    children,
    handleClickBack,
  } = props;
  const { formatMessage } = useIntl(); // 中英切换方法
  const [trendingCardList, setTrendingCardList] = useState([]);
  const [historyList, setHistoryList] = useState([]);
  const [searchHistoriesLoading, setSearchHistoriesLoading] = useState(true);
  const { userInfo } = useSelector((state: any) => {
    const { userInfo } = state.home;
    return {
      userInfo,
    };
  });

  // 搜索历史查询记录
  const getSearchHistories = async () => {
    setSearchHistoriesLoading(true);
    try {
      const result: any = await fetchSearchHistories({
        open_id: userInfo?.openid,
      });
      const _historyList = Array.isArray(result?.data) ? result?.data : [];
      setHistoryList(_historyList);
    } catch (err) {
    } finally {
      setSearchHistoriesLoading(false);
    }
  };

  const turnTrendingList = (list = []) => {
    let cardList: any = [];
    if (Array.isArray(list)) {
      list.map((item: any) => {
        // const tabDataTemp = [
        //   getSearchRelease(item.info?.release_time),
        //   item.info?.publisher,
        // ];
        const listObjTemp = {
          type: item?.info?.entity_type,
          img: item.info?.cover,
          title: item.info?.entity_name,
          release: getSearchRelease(item.info?.release_time),
          publisher: item.info?.publisher,
          // tabData: tabDataTemp,
          trendingData: item,
        };
        cardList.push(listObjTemp);
      });
    }
    return cardList;
  };

  //删除某个搜索历史记录
  const deleteHistoryHandleSearchHome = async (id: any, e: any) => {
    e.stopPropagation();
    setSearchHistoriesLoading(true);
    const params = {
      open_id: userInfo?.openid,
      history_id: Number(id),
    };
    try {
      const result: any = await deleteHistory(params);
      if (result?.code === 0) {
        getSearchHistories();
      }
    } catch (err) {
      setSearchHistoriesLoading(false);
    } finally {
      // setRecentLoading(false);
    }
  };

  const searchRecordsHandle = async (name: string, searchObj: any) => {
    updateSearchPageUrl({ ...getSearchPageParams(), kw: name });
    addSearchHistory(name, searchObj);
  };

  // 删除全部历史记录
  const clearAllHistories = async () => {
    const params = {
      open_id: userInfo?.openid,
      delete_all: true,
      history_id: -1,
    };
    try {
      const result: any = await deleteHistory(params);
      if (result?.code === 0) {
        setHistoryList([]);
      }
    } catch (err) {
    } finally {
    }
  };

  useEffect(() => {
    if (userInfo?.openid) {
      /**首次进来请求热搜词 */
      getSearchHistories();
    }
    //打点
    buriedPointPage(PageLogMes.searchHome);
  }, [userInfo?.openid]);

  useEffect(() => {
    setTrendingCardList(turnTrendingList(trendingList));
  }, [trendingList]);

  return (
    <Card>
      <Card.Body
        title={
          <div className="home-search-title" onClick={handleClickBack}>
            <SvgIcon type="left-pointing" className="home-search-icon" />
            {formatMessage({ id: 'dbh_back' })}
          </div>
        }
      >
        {children}
        {searchTrendingsLoading ? (
          <LodingData />
        ) : (
          <>
            {historyList?.length > 0 ? (
              <>
                <Justify
                  className="search-home"
                  left={
                    <div className="search-home-title">
                      {formatMessage({ id: 'dbh_recent_search' })}
                    </div>
                  }
                  right={
                    <div
                      className="search-home-clear"
                      onClick={clearAllHistories}
                    >
                      {formatMessage({ id: 'dbh_clear_all' })}
                    </div>
                  }
                />
                {searchHistoriesLoading ? (
                  <LodingData loadingHeight={6.2} />
                ) : (
                  <>
                    <div className="search-records">
                      {historyList?.map((item: any, index: number) => {
                        return (
                          <div
                            key={index}
                            className="search-records-item"
                            onClick={() => {
                              searchRecordsHandle(item.entity_name, {});
                            }}
                          >
                            {item.entity_name}
                            <i
                              onClick={(e) => {
                                deleteHistoryHandleSearchHome(item.id, e);
                              }}
                            >
                              <SvgIcon
                                type="clonse"
                                className="search-records-icon"
                              />
                            </i>
                          </div>
                        );
                      })}
                    </div>
                  </>
                )}
              </>
            ) : null}
            <div
              className="search-trending"
            >
              {formatMessage({ id: 'dbh_search_trending' })}
            </div>
            {trendingCardList?.length > 0 ? (
              <Row gap={20}>
                {trendingCardList?.map((e, i) => {
                  return (
                    <Col key={i} span={8}>
                      <CardHomeItem
                        data={e}
                        searchRecordsHandle={searchRecordsHandle}
                      />
                    </Col>
                  );
                })}
              </Row>
            ) : (
              <NoData />
            )}
          </>
        )}
      </Card.Body>
    </Card>
  );
}
